export default class ProductPageBottomStickyService {
    constructor() {
        this.stickyBottomContainer = null;
    }
    createButton() {
        this.stickyBottomContainer = document.querySelector('.bottom-container');
        if (!this.stickyBottomContainer) {
            return;
        }
        const productInfoContainer = document.querySelector('.product-info-add-to-cart button');
        window.addEventListener('scroll', () => this.toggleButton(productInfoContainer));
    }
    cloneButton() {
        const addToCart = document.querySelector('.product-info .btn-single-product');
        const bottomContainer = document.querySelector('.bottom-container-button');
        if (bottomContainer) {
            while (bottomContainer.firstChild) {
                bottomContainer.removeChild(bottomContainer.firstChild);
            }
        }
        if (addToCart) {
            const clonedBtn = addToCart.cloneNode(true);
            bottomContainer === null || bottomContainer === void 0 ? void 0 : bottomContainer.appendChild(clonedBtn);
            clonedBtn === null || clonedBtn === void 0 ? void 0 : clonedBtn.addEventListener('click', (e) => {
                e.preventDefault();
                if (this.stickyBottomContainer) {
                    this.stickyBottomContainer.classList.remove('show');
                }
                const backToTopBtn = document.querySelector('.back-to-top.show');
                if (backToTopBtn) {
                    backToTopBtn.classList.remove('upper');
                }
            });
        }
    }
    toggleButton(productInfoContainer) {
        try {
            const rect = productInfoContainer === null || productInfoContainer === void 0 ? void 0 : productInfoContainer.getBoundingClientRect();
            const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
            const backToTopBtn = document.querySelector('.back-to-top.show');
            const siteFooterContainer = document.querySelector('#site-footer .footer-bottom');
            if (!this.stickyBottomContainer)
                return;
            if (!isVisible) {
                if (!this.stickyBottomContainer.classList.contains('show')) {
                    this.stickyBottomContainer.classList.add('show');
                    this.cloneButton();
                }
                if (backToTopBtn && !backToTopBtn.classList.contains('upper')) {
                    backToTopBtn.classList.add('upper');
                }
                if (siteFooterContainer && !siteFooterContainer.classList.contains('has-sticky-button')) {
                    siteFooterContainer.classList.add('has-sticky-button');
                }
            }
            else {
                this.stickyBottomContainer.classList.remove('show');
                if (backToTopBtn) {
                    backToTopBtn.classList.remove('upper');
                }
                if (siteFooterContainer) {
                    siteFooterContainer.classList.remove('has-sticky-button');
                }
            }
        }
        catch (e) {
            console.log(e);
        }
    }
    init() {
        this.createButton();
    }
}
